import { render, staticRenderFns } from "./RolDeleteModal.vue?vue&type=template&id=0067de7a&scoped=true&"
import script from "./RolDeleteModal.vue?vue&type=script&lang=js&"
export * from "./RolDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0067de7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0067de7a')) {
      api.createRecord('0067de7a', component.options)
    } else {
      api.reload('0067de7a', component.options)
    }
    module.hot.accept("./RolDeleteModal.vue?vue&type=template&id=0067de7a&scoped=true&", function () {
      api.rerender('0067de7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/roles/RolDeleteModal.vue"
export default component.exports